import { atom } from 'recoil';

// 유저 정보 관리
export const userNameText = atom<string | null>({
    key: 'userNameText',
    default: null,
});